import { render, staticRenderFns } from "./DocumentationPage.vue?vue&type=template&id=caa971a2&scoped=true&"
import script from "./DocumentationPage.vue?vue&type=script&lang=js&"
export * from "./DocumentationPage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationPage.vue?vue&type=style&index=0&id=caa971a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa971a2",
  null
  
)

export default component.exports